import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class ApproachAssignmentService {

  programPaths = ["Traditional Class B", "Traditional Class A", "Traditional Class AA", "Alternative Class A", "Innovative"]

  constructor(
    public http : AppHttpClient,
    public util : UtilService
  ) { }

  getAssignments(approach:string){
    return this.http.get('teaching-fields/approaches?approach='+approach);
  }

  getAssignmentsByTeachingFieldId(teachingFieldId:string){
    return this.http.get('teaching-fields/approaches?teachingFieldId='+teachingFieldId);
  }

  createAssignment(payload: any){
    return this.http.post('teaching-fields/approaches', payload);
  }

  updateAssignment(payload: any){
    return this.http.put('teaching-fields/approaches', payload);
  }

  deleteAssignment(params: any){
    return this.http.delete('teaching-fields/approaches', { params });
  }

  getApproaches(){
    return this.http.get('teaching-fields/approaches');
  }
}
